import type { StateCreator } from 'zustand';

import { LightboxSource, type LightboxSlice } from './types';

export type { LightboxSlice, OpenLightboxParams } from './types';
export { LightboxSource } from './types';

export const lightboxInitialState: Pick<
  LightboxSlice,
  'lightboxItems' | 'lightboxIndex' | 'lightboxSource' | 'isLightboxResultMode'
> = {
  lightboxItems: [],
  lightboxIndex: 0,
  lightboxSource: LightboxSource.Creations,
  isLightboxResultMode: false,
};

export const createLightboxSlice: StateCreator<
  LightboxSlice,
  [],
  [],
  LightboxSlice
> = (set) => ({
  ...lightboxInitialState,

  openLightbox: ({ items, index = 0, source, resultMode = false }) =>
    set({
      lightboxItems: items,
      lightboxIndex: Math.min(Math.max(index, 0), items.length - 1),
      lightboxSource: source,
      isLightboxResultMode: resultMode,
    }),

  closeLightbox: () => set(lightboxInitialState),

  setLightboxIndex: (index) =>
    set((state) =>
      index >= 0 && index < state.lightboxItems.length
        ? { lightboxIndex: index }
        : state
    ),

  updateLightboxItem: ({ uuid, updates }) =>
    set((state) => ({
      lightboxItems: state.lightboxItems.map((item) =>
        item.uuid === uuid ? { ...item, ...updates } : item
      ),
    })),
});
